export enum CompanyObjectiveKeyResultTitleRejectionReason {
  LooksLikeObjective = 'looks_like_objective',
  LooksLikeOutput = 'looks_like_output',
  NotMeasurable = 'not_measurable',
}

export const COMPANY_OBJECTIVE_KEY_RESULT_TITLE_REJECTION_REASON_LABELS: Record<CompanyObjectiveKeyResultTitleRejectionReason, string> = {
  [CompanyObjectiveKeyResultTitleRejectionReason.LooksLikeObjective]: 'Esto parece un Objective',
  [CompanyObjectiveKeyResultTitleRejectionReason.LooksLikeOutput]: 'Esto parece un entregable, no un resultado',
  [CompanyObjectiveKeyResultTitleRejectionReason.NotMeasurable]: 'No se puede medir de forma objetiva',
};
